// ETHRAEON Home page · Phase S
// Copy verbatim from evidence/launch/PHASE_S_COPY_DOCTRINE.md
// (c) S. Jason Prohaska (ingombrante) 2024-2026

import { DemoCard } from "../components/DemoCard";
import {
  IconConstitutionalShell,
  IconDIM,
  IconRecursiveWitness,
  IconEthraeonTrinity,
} from "../components/icons";

export function Home() {
  return (
    <main className="min-h-screen bg-white dark:bg-neutral-950 text-neutral-900 dark:text-neutral-50">
      <section className="max-w-5xl mx-auto px-6 py-24">
        <h1 className="text-4xl md:text-6xl font-light tracking-tight">
          Humanitas ante Machinam - Humanity before the Machine.
        </h1>
        <p className="mt-6 text-lg text-neutral-600 dark:text-neutral-400 max-w-3xl">
          Ethraeon builds orchestration that keeps people at the center of every decision.
        </p>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-2 gap-4">
          <DemoCard
            icon={<IconConstitutionalShell className="w-8 h-8" />}
            title="Constitutional AI Shell"
            subtitle="Integrity, held with openness."
          />
          <DemoCard
            icon={<IconDIM className="w-8 h-8" />}
            title="Decision Insight Model"
            subtitle="Options, not outcomes."
          />
          <DemoCard
            icon={<IconRecursiveWitness className="w-8 h-8" />}
            title="Recursive Witness OS"
            subtitle="Reflection without capture."
          />
          <DemoCard
            icon={<IconEthraeonTrinity className="w-8 h-8" />}
            title="Ethraeon Trinity"
            subtitle="Three lenses, one intention."
          />
        </div>
      </section>
    </main>
  );
}
